module.exports = "/packs/images/pages/venues/gym_desktop~84eaa78f2d001162e70c31b08e29770e.jpg";